import Vue from 'vue'
import Router from 'vue-router'
import store from "../store"
Vue.use(Router)

import { getUrlQuery } from '../tools/index';
import { statics_channel, statics_pu } from "../request/api.user/all"

// // 工程化引入文件
var routerLists = [];
function importAll(arr) {
  arr.keys().forEach(key => {
    routerLists = routerLists.concat(arr(key).default)
  })
}
importAll(require.context('.', true, /\.routers.js/));


// 【添加代码】解决vue-router在3.0版本以上重复点路由报错
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}


const router = new Router({
  mode: "history", // history
  base: process.env.BASE_URL,
  hasMenu: false, //是否获取路由
  routes: [
    {
      path: '/error',
      name: 'error',
      component: () => import('../views/common/error.vue'),
      meta: { title: '哎呀,出错了', }
    },
    ...routerLists,
    
  ]
});
export default router


router.beforeEach((to, from, next) => {
  // console.log(router.options)
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.name !== 'articles' && to.name !== 'category'){
    sessionStorage.clear();
  } 
  // 访问用户端
  if (to.path.indexOf('admin') == -1 && to.name != 'error') {
    let code = getUrlQuery({ key: 'f' })
    if (code) {
      sessionStorage.setItem('code', code)
    }
    let params = {
      code: sessionStorage.getItem('code') || '',
      pageCode: getPageCode[to.name]
    }
    statics_pu(params).then(res => { })
    if (params['code']) {
      statics_channel(params).then(res => { })
    }
  }else{
    if (!Vue.cookie.get('token') && to.name != 'login' ){
      next('/admin/login')
    }
  }
  next();
  window.scrollTo(0, 0);
 
});

const getPageCode = {
  "index": "INDEX", // 首页
  "dynamic": "DYNAMIC", // 动态
  "articles": "DYNAMIC", //动态
  "about": "ABOUT_US", // 关于我们
  "contact": "CONTACT_US",  // 联系我们
  "intimate": "INTIMATE_HEALTH",//贴心健康
  "category": "INTIMATE_HEALTH",//贴心健康-类目
  "diagnosis": "9HYZ",//9号云诊
}
